import * as React from 'react'
import classNames from 'classnames'

import { Dropdown, DropdownOption } from '../../Menus/Dropdown'
import { useMediaQuery } from '../../MediaQuery'
import Button from 'content-components/_Primatives/Button'

import style from './style.scss'

const PROFILE_URL = process.env.PROFILE_URL

export type Props = {
  className?: string
  isExpanded?: boolean
  isLoggedIn?: boolean
  loginButtonText: string
  logoutText: string
  onClick: () => void
  onLogout: () => void
  userFirstName?: string
  viewProfileText: string
  welcomeButtonText: string
}

function LoginButton({
  className,
  isExpanded = false,
  isLoggedIn = false,
  loginButtonText,
  onClick,
  onLogout,
  userFirstName,
  welcomeButtonText,
  viewProfileText,
  logoutText,
}: Props) {
  const { belowTablet } = useMediaQuery({ tablet: true })

  return (
    <div
      className={classNames(style.wrapper, className)}
      data-testid='login-button'
    >
      {isLoggedIn ? (
        belowTablet ? (
          <>
            <a className={style.mobileMenuLogin} href={PROFILE_URL}>
              {viewProfileText}
            </a>
            <button className={style.mobileMenuLogin} onClick={onLogout}>
              {logoutText}
            </button>
          </>
        ) : (
          <>
            <Button
              className={classNames(style.button, style.loggedInButton)}
              id='login-button'
              variant='primaryGray'
            >
              {welcomeButtonText} {userFirstName}
            </Button>
            <Dropdown className={style.dropdown} isExpanded={isExpanded}>
              <DropdownOption url={PROFILE_URL}>
                {viewProfileText}
              </DropdownOption>
              <DropdownOption onClick={onLogout}>{logoutText}</DropdownOption>
            </Dropdown>
          </>
        )
      ) : belowTablet ? (
        <button
          className={style.mobileMenuLogin}
          id='login-button'
          onClick={onClick}
        >
          {loginButtonText}
        </button>
      ) : (
        <Button
          className={classNames(style.button, style.loginButton)}
          id='login-button'
          variant='primaryBlue'
          onClick={onClick}
        >
          {loginButtonText}
        </Button>
      )}
    </div>
  )
}

export default LoginButton
